import classnames from 'classnames';
import type { EntryFlashPhase } from '../use-entry-flash';
import styles from './EntryFlash.module.scss';

/** The white flash the party enters a Crucible through, over the whole screen (see `useEntryFlash`). */
export function EntryFlash({ phase }: { readonly phase: EntryFlashPhase }): JSX.Element | null {
    if (phase === 'none') {
        return null;
    }
    return <div className={classnames(styles.entryFlash, phase === 'out' && styles.fadingOut)} aria-hidden='true' />;
}
